import httpStore from "@/api/httpStore.js";

export function getPackingManifest(orderNumber) {
  return httpStore
    .get(`/orders/packing_manifest/${orderNumber}`)
    .then(res => res.data);
}

export function createManifestBulto(orderNumber, bulto) {
  return httpStore
    .post(`/orders/packing_manifest_bulto/${orderNumber}`, bulto)
    .then(res => res.data);
}

export function updateManifestBulto(orderNumber, bultoId, bulto) {
  return httpStore
    .post(`/orders/packing_manifest_bulto_update/${orderNumber}`, {
      bulto_id: bultoId,
      ...bulto
    })
    .then(res => res.data);
}

export function deleteManifestBulto(orderNumber, bultoId) {
  return httpStore
    .delete(`/orders/packing_manifest_bulto/${orderNumber}?bulto_id=${bultoId}`)
    .then(res => res.data);
}

export function updateManifestDispatchInfo(orderNumber, dispatch) {
  return httpStore
    .post(`/orders/packing_manifest_dispatch/${orderNumber}`, dispatch)
    .then(res => res.data);
}

export function closeManifest(orderNumber) {
  return httpStore
    .post(`/orders/packing_manifest_close/${orderNumber}`, {})
    .then(res => res.data);
}

export function reopenManifest(orderNumber) {
  return httpStore
    .post(`/orders/packing_manifest_reopen/${orderNumber}`, {})
    .then(res => res.data);
}

// Otra orden existente que se despacha en los mismos bultos.
export function linkManifestOrder(orderNumber, linkedOrderNumber) {
  return httpStore
    .post(`/orders/packing_manifest_link_order/${orderNumber}`, {
      linked_order_number: linkedOrderNumber
    })
    .then(res => res.data);
}

export function unlinkManifestOrder(orderNumber, linkedOrderNumber) {
  return httpStore
    .post(`/orders/packing_manifest_unlink_order/${orderNumber}`, {
      linked_order_number: linkedOrderNumber
    })
    .then(res => res.data);
}
